import { Button, Tooltip } from "@mui/material";
import { faCloudArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode, useState } from "react";

import SubmitOnlineDialog from "./SubmitOnlineDialog";
import EasySnackbar from "./EasySnackbar";

export default function SubmitOnlineButton({
  children = "Save Project Online",
  disabled,
  onBeforeSave,
  tooltipText,
}: {
  children: ReactNode;
  disabled: boolean;
  onBeforeSave?: () => void;
  tooltipText?: string;
}): JSX.Element {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");

  const handleClose = () => setShowDialog(false);

  const handleClick = () => {
    if (onBeforeSave) {
      onBeforeSave();
    }
    setShowDialog(true);
  };

  return (
    <>
      <Tooltip title={tooltipText}>
        <div>
          <Button
            color="secondary"
            disabled={disabled}
            onClick={handleClick}
            startIcon={<FontAwesomeIcon icon={faCloudArrowUp} />}
            variant="outlined"
          >
            {children}
          </Button>
        </div>
      </Tooltip>
      {showDialog && (
        <SubmitOnlineDialog
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarMessage={setSnackbarMessage}
          handleClose={handleClose}
        />
      )}
      <EasySnackbar
        alertProps={{ children: snackbarMessage }}
        isOpen={isSnackbarOpen}
        setIsOpen={setIsSnackbarOpen}
      />
    </>
  );
}
